import styled, { css } from 'styled-components';

export interface MultipleColumnLayoutProps {
  itemMinWidth: number;
  rowGap: number;
  columnGap: number;
}

const itemMinWidth = (props) => `${props.itemMinWidth}px`;
const rowGap = (props) => `${props.rowGap}px`;
const columnGap = (props) => `${props.columnGap}px`;

export const MultipleColumnLayoutCSS = css`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(${itemMinWidth}, 1fr));
  grid-row-gap: ${rowGap};
  grid-column-gap: ${columnGap};
`;

export const MultipleColumnLayout = styled.div<MultipleColumnLayoutProps>`
  ${MultipleColumnLayoutCSS}
`;
